<template>
  <v-dialog v-model="dialog" width="600">
    <v-card>
      <v-card-title class="headline">
        Anuluj zamówienie
      </v-card-title>
      <v-card-text>
        <v-form
            ref="newForm"
            v-model="valid"
            lazy-validation
            class="dimension--form mt-5 mb-5"
        >
          <v-row>
            <v-col cols="12" md="12" align-self="start" dense>
              <v-textarea
                  v-model="order.reason"
                  class="pt-0"
                  type="url"
                  label="Powód"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                @click.prevent="onSubmit"
                type="Submit"
                color="red lighten-1"
                large
            >Anuluj&nbsp;<v-icon size="24">mdi-send</v-icon>
            </v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import api from "@/services/api";

export default {
  name: 'ModalCancelOrder',
  props: {
    order: {},
  },
  created() {
  },
  data() {
    return {
      dialog: false,
      form: {
        reason: null,
      },
      valid: false,
    }
  },
  methods: {
    open() {
      this.dialog = true
    },
    async onSubmit() {
      if (!this.$refs.newForm.validate()) {
        return
      }

      await api.post(`/api/orders/${this.order.id}/cancel`, {reason: this.order.reason})
          .then(() => {
            this.$root.$emit('notifySuccess', {
              html: 'Zamówienie zostało anulowane.',
            });
            this.dialog = false;
            this.$parent.loadDetails();
          })
          .catch((error) => {
            console.error('Error when canceling a order:', error);
            this.$root.$emit('notifyError', {
              html: 'Wystąpił błąd.',
            });
          })
    },
  },
}
</script>

<style scoped></style>
